'use strict';
//uses 'international' namespace to avoid conflicts with other apps
module.exports = require('store2').namespace('international');


//////////////////
// WEBPACK FOOTER
// ./src/international/scripts/utils/store.js
// module id = juAn
// module chunks = 0 1 2 3 4 5 6 7 8